<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <div class="page-header-grid grid-sm">
      <h1 class="page-header-title">
        {{ 'saleModule.sales' | translate }}
      </h1>

      <div
        [canSee]="[accessRights.Sales_write]"
        *ngIf="
          !(
            hasRequiredRole$(moduleConfigs.saleModule.rolesWithWritePermission)
            | async
          )
        "
      >
        <button class="btn btn-primary" (click)="onClickCreate()">
          {{ 'general.create' | translate }}
        </button>
      </div>
    </div>
  </header>
  <!-- End Page Header -->

  <dms-table
    [filters]="filters"
    [activeTab]="0"
    [isLoading]="isLoading$ | async"
    [showTotal]="true"
    [tableType]="'sales'"
    (onBulkAction)="onBulkAction($event)"
    (onClickRow)="onClickRow($event)"
    [mainFilters]="mainFilters"
    [readonly]="
      !(
        hasRequiredRole$(moduleConfigs.saleModule.rolesWithWritePermission)
        | async
      )
    "
  >
  </dms-table>
</div>
